var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:{disabled: !_vm.active},attrs:{"to":{ name: _vm.routerName, params: { ..._vm.params }}}},[_c('i',{staticClass:"fas fa-pen"})])
}
var staticRenderFns = []

export { render, staticRenderFns }